import React, { useEffect } from "react";
import _ from "lodash";
import cx from "classnames";
import Reveal from "src/components/animation";
import styles from "./error.module.scss";
import { SimulationValidationError } from "src/types/coaching/simulation";


interface ErrorMessageProps {
  error: SimulationValidationError | null;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ error }) => {
  const errorType = error?.warning ? "warning" : "error";
  return (
    <Reveal className={styles[errorType]} show={error != null}>
      <i className={cx("fa-solid", "fa-triangle-exclamation")}></i>
      <span>{error?.message}</span>
    </Reveal>
  );
}